<template>
  <div class="root" :style="{ display: sourceCustomerRemarks.records.length ? undefined : 'none' }">
    <h5 class="blue-text">{{L10n('supplier-remarks')}}</h5>
    <el-descriptions class="margin-top" :column="1" size="small" border>
      <template v-for="item in sourceCustomerRemarks.records">
        <el-descriptions-item :key="item.id" :label="item.title">
          {{item.description}}
        </el-descriptions-item>
      </template>
    </el-descriptions>
  </div>

</template>

<script>
export default {
  name: 'CustomerMarketData',
  props: {
    supplierCompanyID: { type: String }
  },
  computed: {
    sourceCustomerRemarks () {
      console.log(this.supplierCompanyID)
      if (!this.supplierCompanyID) {
        return { records: [] }
      }
      return this.API(`CompanyRemarks/GetAllDynamic?select=id,companyRemarkSubject.subject as title,remark as description&Filter=companyID=="${this.supplierCompanyID}"`)
    }
  }
}
</script>
<style scoped>
.root{
  margin-top: 1rem;
}
</style>
